require('../bootstrap');

import env from '../config/env';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;

const store = {
  state: {
    user: {
      name: '',
      picture: '',
      job: '',
      email: '',
      id: 0,
      is_admin: false,
      remote_check: 0
    },
    closeMirror: {},
    authenticated: false,    
    token: '',
    api: baseURL,
    url: normalURL,
    breadcrumbs: [{
      name: "Home",
      route: "/"
    }],
    has_signature: false
  },
  getters: {
    has_signature: state => {
      return state.has_signature;
    },
    getCloseMirror: state => {
      return state.closeMirror;
    },
    token: state => {
      return state.token;
    },
    authenticated: state => {
      if (state.token == null || state.token == 'null') {
        return false;
      }

      return state.authenticated;
    },
    logo: state => {
      return state.logo;
    },
    user: state => {
      return state.user;
    },
    api: state => {
      return state.api;
    },
    breadcrumbs: state => {
      return state.breadcrumbs;
    }
  },
  mutations: {
    auth(state, token) {
      if (token != null && token != undefined) {
        state.authenticated = true;
        state.token = token;

        localStorage.clear();
        localStorage.setItem('token', token);

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
        this.commit('profileUpdate');
        this.commit('getConfiguration');
      }
    },
    close_mirror(state, data) {
      state.closeMirror = data;
    },
    getConfiguration(state){
      axios.get(state.api + 'configurations')
      .then(response => {
          state.has_signature = response.data.data[0].has_signature
      })
    },  
    profileUpdate(state) {
      axios.post(state.api + 'me', {
          token: state.token
        })
        .then(response => {
          state.user.id = response.data.id;
          state.user.name = response.data.name;
          state.user.email = response.data.email;
          state.user.picture = response.data.photo;
          state.user.is_admin = response.data.is_admin;
          state.user.remote_check = response.data.remote_check;

          localStorage.setItem("is_admin", response.data.is_admin)
        })
        .catch(error => {
          localStorage.clear();

          router.push('/login');
        });
    },
    updateBreadCrumbs(state, newRoute) {
      if (state.breadcrumbs.length > 1) {
        state.breadcrumbs.pop();
      }
      state.breadcrumbs.push(newRoute)
      // state.breadcrumbs = newRoute;
    }
  },
  actions: {
    initialize(context) {
      const token = localStorage.getItem('token');

      context.commit('auth', token);
    }
  }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js